export default "__VITE_ASSET__m0z4VeWs__"